import { Button, Input, Select } from 'antd';
import React, { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { CSVLink } from 'react-csv';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Container from '../../../../components/Container/Container';
import {
  secondaryPermission,
  SupplierModuleTypeEnum,
} from '../../../../utils/settings';
import { GetDealerCompanies } from '../../../auth/action/util_actions';
import {
  CreateLedgerPayment,
  getCheckIfLedgerBalanceFile,
  getLedgerDueAmountAction,
  updateLedgerPayment,
} from '../../action/util_action';

import './payment.less';
import { Box } from '@mui/material';
import { getCompanySuppliersAction } from '../../../../v2/BCMOrder/Action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Payment() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);

  const [obj, setObj] = useState({ paymentType: 1 });
  const [dueAmount, setDueAmount] = useState({});

  // Show download file
  const [showDownloadFile, setShowDownloadFile] = useState(false);
  const [lastUpdateDate, setLastUpdateDate] = useState(null);
  const [csvFile, setCsvFile] = useState([]);
  const csvRef = useRef();

  const getAllCompanies = async () => {
    setLoading(true);
    const { error, data, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.payment_enabled,
    );
    setLoading(false);

    if (!error) {
      const temp = data
        .map((item) => {
          return item.suppliers_list;
        })
        .flat();

      setObj({
        ...obj,
        seller_id: temp[0].id,
      });

      setCompanies(
        temp.map((item) => {
          return (
            <Select.Option
              value={item.id}
              name={item.name}
              key={item.id}
            >
              {item.name}
            </Select.Option>
          );
        }),
      );
    }
  };

  // data for leger Table
  const getDueAmount = async () => {
    const { error, data, message } = await getLedgerDueAmountAction({
      seller_id: obj.seller_id,
      supplier_id: obj.seller_id,
    });

    if (!error) {
      setLastUpdateDate(data?.last_updated_date_time);
      setDueAmount(data);
    }
  };

  // Checking for file
  const checkIfFile = async () => {
    const data = await getCheckIfLedgerBalanceFile();

    if (!!data && !data?.error) {
      setShowDownloadFile(!!data);

      setCsvFile(data);
    }
  };

  const updateStatus = async (txnid) => {
    const { data, error, message } = await updateLedgerPayment({
      txnid: String(txnid),
    });
  };

  // function for calling payment window
  const paymentProcedure = async ({ error, message, data }) => {
    if (error) {
      toast.error(message);
      return;
    }
    const paymentModeBillDesk = () => {
      const form = document.createElement('form');
      form.name = 'Billdesk';
      form.method = 'POST';
      form.action = process.env.REACT_APP_BILLDESK_CHECKOUT_URL;
      const payloadField = document.createElement('input');
      payloadField.type = 'hidden';
      payloadField.name = 'msg';
      payloadField.value = data.msg;
      form.appendChild(payloadField);
      document.body.appendChild(form);
      form.submit();
    };

    const paymentModeEaseBuzz = () => {
      const EasebuzzCheckout = window.EasebuzzCheckout;

      var easebuzzCheckout = new EasebuzzCheckout(
        process.env.REACT_APP_EASEBUZZ_KEY,
        process.env.REACT_APP_EASEBUZZ_ENV,
      );
      var options = {
        access_key: data.access_key, // access key received via Initiate Payment
        onResponse: (response) => {
          if (response.status === 'success') {
            toast.success('Payment Successful');
            updateStatus(response.txnid);
            // navigate('/distributor/ledgerBalance');
          } else if (response.status === 'userCancelled') {
            toast.error('Payment Unsuccessful');
            updateStatus(response.txnid);
            setObj({
              seller_id: obj.seller_id,
            });
          }
        },
        theme: '#F49D3F', // color hex
      };
      easebuzzCheckout.initiatePayment(options);
    };
    data && data.msg ? paymentModeBillDesk() : paymentModeEaseBuzz();
  };

  // Injecting EasebuzzCheckout object
  useEffect(() => {
    const script = document.createElement('script');

    script.src =
      'https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/easebuzz-checkout.js';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const PaymentType = [
    { label: 'Top-Up Your Account', value: 1, valueToSend: true },
  ];

  const onFinish = async ({ advance }) => {
    if (!obj.seller_id) {
      return toast.error('Select Company');
    }
    if (!obj.amount) {
      return toast.error('Enter Amount');
    }

    setLoading(true);
    let payload = {
      manufacturer_id: obj.seller_id,
      amount: obj.amount,
      advance: PaymentType[obj.paymentType - 1].valueToSend,
      return_url: process.env.REACT_APP_BILLDESK_RETURN_URL,
    };
    const response = await CreateLedgerPayment(payload);

    setLoading(false);

    paymentProcedure(response);
  };

  useEffect(() => {
    getDueAmount();
  }, [obj.seller_id]);

  useEffect(() => {
    getAllCompanies();
  }, []);

  return (
    <Box
      sx={{
        padding: 2,
        overflowY: 'scroll',
        backgroundColor: 'rgba(217, 217, 217, .1)',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div className='payment_subcontainer'>
        <div
          className='payment_shadow'
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            // width: "100%"
          }}
        >
          <div
            className='payment_title'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <h2
              className='payment_title-text'
              style={{ flex: 3 }}
            >
              Payment
            </h2>
            {showDownloadFile ? (
              <>
                <Button
                  block
                  type='primary'
                  style={{
                    width: '15rem',
                    marginLeft: 'auto',
                  }}
                  // className='addproduct-btn retailer__addbtn'
                  onClick={() => csvRef.current.link.click()}
                >
                  <b className='btnText'> Downloads Ledger Transaction </b>
                </Button>
                <div style={{ opacity: 0, width: 0, height: 0 }}>
                  <CSVLink
                    data={csvFile ? csvFile : []}
                    ref={csvRef}
                    filename={'ledgerBalance'}
                  />
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          <div className='payment_fieldcontainer'>
            <div className='payment_sellerFields'>
              <h5 style={{ margin: '0' }}>Select Company</h5>
              <Select
                className='orderBookingCompanySelection'
                showSearch
                allowClear
                layout='vertical'
                optionFilterProp='children'
                placeholder={t('addInvoice.searchCompany')}
                value={obj.seller_id}
                style={{ width: '100%' }}
                onChange={(e) => {
                  setObj({ ...obj, seller_id: e });
                }}
              >
                {companies}
              </Select>
            </div>
            <div className='payment_sellerFields'>
              <h5 style={{ margin: '0' }}>Payment Type</h5>
              <Select
                className='orderBookingCompanySelection'
                layout='vertical'
                optionFilterProp='children'
                placeholder={t('addInvoice.searchCompany')}
                value={obj.paymentType}
                style={{ width: '100%' }}
                defaultValue={false}
                onChange={(e) => {
                  setObj({ ...obj, paymentType: e });
                }}
                options={PaymentType}
              />
            </div>
          </div>

          <div
            className='payment_fieldcontainer'
            style={{ marginTop: '10px' }}
          >
            <div className='payment_sellerFields'>
              <h5 style={{ margin: '0' }}>Enter Amount</h5>
              <Input
                placeholder='Enter Amount'
                allowClear
                value={obj.amount}
                style={{ width: '100%' }}
                onKeyPress={(e) => {
                  const key = e.key;
                  if (
                    (key !== '.' && isNaN(key)) ||
                    (key === '.' && e.target.value.includes('.'))
                  ) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) =>
                  setObj({
                    ...obj,
                    amount: e.target.value,
                  })
                }
              />
            </div>

            <div className='payment_sellerFields'>
              <Button
                block
                type='primary'
                onClick={() => onFinish({ advance: false })}
                style={{ marginTop: 18, width: '100%' }}
              >
                Pay Now
              </Button>
            </div>
          </div>

          {showDownloadFile ? (
            <h3
              style={{
                textAlign: 'start',
                width: '100%',
                paddingTop: '20px',
                padding: '10px',
              }}
            >
              Last Updated Date: {lastUpdateDate ? lastUpdateDate : '-'}
            </h3>
          ) : (
            <div />
          )}
          <div
            className='payment_tablectr'
            style={{ marginTop: 10 }}
          >
            <div className='payment_tablerow'>
              <div className='payment_table-title'>
                <h3 className='payment_fonttitle'>
                  Dispatch Plan Order Value
                </h3>
              </div>
              <div className='payment_table-subtitle'>
                <h3 className='payment_table-data'>
                  ₹{' '}
                  {`${Number(
                    dueAmount.order_due_amount
                      ? dueAmount.order_due_amount
                      : '00',
                  ).toFixed(2)}`}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
